/**
 * @generated SignedSource<<59a6090f2b60e6ba24a438778fe9d76e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceSearchType = "PARENT" | "WHAT" | "WHO";
export type SalesforceSelectSearchQuery$variables = {
  searchType: SalesforceSearchType;
  text: string;
};
export type SalesforceSelectSearchQuery$data = {
  readonly salesforceSearch: ReadonlyArray<{
    readonly __typename: "SalesforceAccountNode";
    readonly id: string;
    readonly name: string;
    readonly url: string;
  } | {
    readonly __typename: "SalesforceCaseNode";
    readonly caseNumber: string;
    readonly description: string | null;
    readonly id: string;
    readonly subject: string | null;
    readonly url: string;
  } | {
    readonly __typename: "SalesforceContactNode";
    readonly email: string | null;
    readonly id: string;
    readonly name: string;
    readonly title: string | null;
    readonly url: string;
  } | {
    readonly __typename: "SalesforceLeadNode";
    readonly company: string;
    readonly id: string;
    readonly name: string;
    readonly url: string;
  } | {
    readonly __typename: "SalesforceOpportunityNode";
    readonly amount: string | null;
    readonly id: string;
    readonly name: string;
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
};
export type SalesforceSelectSearchQuery = {
  response: SalesforceSelectSearchQuery$data;
  variables: SalesforceSelectSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "searchType",
        "variableName": "searchType"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "salesforceSearch",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "type": "SalesforceContactNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "type": "SalesforceAccountNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "type": "SalesforceOpportunityNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "type": "SalesforceCaseNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "company",
            "storageKey": null
          }
        ],
        "type": "SalesforceLeadNode",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceSelectSearchQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SalesforceSelectSearchQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "e3990180e36cf430f5111700aaee254c",
    "id": null,
    "metadata": {},
    "name": "SalesforceSelectSearchQuery",
    "operationKind": "query",
    "text": "query SalesforceSelectSearchQuery(\n  $text: String!\n  $searchType: SalesforceSearchType!\n) {\n  salesforceSearch(text: $text, searchType: $searchType) {\n    __typename\n    ... on SalesforceContactNode {\n      id\n      url\n      name\n      title\n      email\n    }\n    ... on SalesforceAccountNode {\n      id\n      url\n      name\n    }\n    ... on SalesforceOpportunityNode {\n      id\n      url\n      name\n      amount\n    }\n    ... on SalesforceCaseNode {\n      id\n      url\n      subject\n      caseNumber\n      description\n    }\n    ... on SalesforceLeadNode {\n      id\n      url\n      name\n      company\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec98043d613c36252e47710d739ce1c9";

export default node;
